import styled from "styled-components";
import HorizontalScrollCarousel from "components/HorizontalScrollCarousel";

export const Section = styled.section`
  border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  padding: 8px 0 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &:last-child {
    border-bottom: 0;
  }
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(140px, 220px);
  gap: 20px;
  align-items: center;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const StepMeta = styled.div`
  margin-bottom: 7px;
  color: ${({ theme }) => theme.palette.blue.main};
  font-size: 18px;
  font-weight: 800;
  line-height: 1.4;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

export const StepTitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 24px;
  line-height: 1.2;
`;

export const StepDescription = styled.p`
  margin: 7px 0 0;
  max-width: 760px;
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 20px;
  line-height: 1.55;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.colors.surfaceElevated};
`;

export const ProgressFill = styled.div`
  height: 100%;
  border-radius: inherit;
  background: ${({ theme }) => theme.palette.blue.main};
`;

export const ItemCarousel = styled(HorizontalScrollCarousel)`
  width: 100%;
  min-width: 0;

  > div {
    width: 100%;
  }

  [style*="grab"] {
    padding: 2px 0 4px;
    scroll-snap-type: x proximity;
  }
`;
